import React, { useState } from 'react';
import Slider from 'react-slick';
import { Box, Image, Button, useBreakpointValue, useColorMode } from '@chakra-ui/react';
import { ChevronRightIcon, ChevronLeftIcon } from '@chakra-ui/icons';

// Components
import { LeftIcon, RightIcon } from 'components/Icons/Icons';

const NextArrow = ({ onClick }) => (
    <Button
      variant="button-lg"
        onClick={onClick}
        position="absolute"
        right={{base: '-35px', md: '8px'}}
        top="50%"
        w="64px"
        mt="-20px"
        transform="translateY(-50%)"
        zIndex="1"
        borderRadius="full"
        _hover={{ bg: '#2ABDFD' }}
    >
      <RightIcon fontSize="24px" />   
    </Button>
);

const PrevArrow = ({ onClick }) => (
    <Button
      variant="button-lg"
        onClick={onClick}
        position="absolute"
        left={{base: '-35px', md: '8px'}}
        top="50%"
        mt="-20px"
        w="64px"
        transform="translateY(-50%)"
        zIndex="1"
        borderRadius="full"
        _hover={{ bg: '#2ABDFD' }}
    >
        <LeftIcon fontSize="24px" />
    </Button>
);

const GiveawayGallery = ({ images }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const sliderRef = React.useRef(null);
  const sliderRefMini = React.useRef(null);

  const isMobile = useBreakpointValue({ base: true, md: false });

  const handleSlideChange = (next) => {
    setActiveSlide(next);
    sliderRefMini.current?.slickGoTo(next);
  };

  const handleThumbnailClick = (index) => {
    setActiveSlide(index);
    sliderRef.current?.slickGoTo(index);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: !isMobile ? <NextArrow /> : <></>,
    prevArrow: !isMobile ? <PrevArrow /> : <></>,
    beforeChange: (current, next) => handleSlideChange(next),
    appendDots: dots => (
      <Box mt="10px">
        {!isMobile && (
          <ul style={{ display: 'flex', justifyContent: 'center', gap: '4px' }}>
            {dots}
          </ul>
        )}
      </Box>
    ),
    customPaging: i => (
      <Box w="8px" h="8px" bg={i === activeSlide ? '#2ABDFD' : '#8794C2'} borderRadius="full" />
    ),
    focusOnSelect: false, 
  };

  const settingsMini = {
    infinite: images.length > 7 ? true : false,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 1,
    nextArrow: <></>,
    prevArrow: <></>,
    centerMode: true,
    beforeChange: (current, next) => setActiveSlide(next),
    focusOnSelect: false, 
  };

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  return (
    <Box position="relative" className="giveaways-gallery">
      <Slider ref={sliderRef} {...settings}>
        {images.map((src, index) => (
          <Box key={index}>
            <Image
              src={src}
              alt={`Slide ${index}`}
              borderRadius="16px"
              w="100%"
              maxH="635px"
              border="1px solid #2ABDFD"
              boxShadow={ isDark ? '0px 1px 22.4px 0px rgba(9, 155, 255, 0.60)' : 'unset'}
              h={{ base: '224px', md: '400px', lg: '100%' }}
              objectFit="cover"
            />
          </Box>
        ))}
      </Slider>

      {!isMobile && (
        <Box className="giveaways-gallery-mini" overflow="hidden">
          <Slider ref={sliderRefMini} {...settingsMini} style={{ gap: '16px' }}>
            {images.map((src, index) => (
              <Box key={index} px="8px">
                <Image
                  src={src}
                  alt={`Thumbnail ${index}`}
                  objectFit="cover"
                  borderRadius="16px"
                  h="79px"
                  w="100%"
                  bg="lightgray 50% / cover no-repeat"
                  onClick={() => handleThumbnailClick(index)}
                  cursor="pointer"
                  border={index === activeSlide ? '2px solid #2ABDFD' : 'none'}
                />
              </Box>
            ))}
          </Slider>
        </Box>
      )}
    </Box>
  );
};

export default GiveawayGallery;
